import React from 'react';
import Card, { CardHeader } from '../ui/Card';

const ToolLayout = ({ title, description, category, note, children, actions }) => {
  return (
    <div className="tool-page">
      <Card className="tool-page__hero">
        <CardHeader
          eyebrow={category}
          title={title}
          description={note || description}
          action={actions}
        />
      </Card>
      {children}
    </div>
  );
};

export default ToolLayout;
